import React from 'react'
import cn from 'classnames'
import PropTypes from 'prop-types'
import Image, { ImageProps } from '../Image'

type TileImageProps = Omit<ImageProps, 'src'> &
  (
    | {
        image: React.ComponentElement<ImageProps, Image>
        imageUrl?: undefined
      }
    | {
        image?: undefined
        imageUrl: string
      }
  )

const TileImage = ({ className, ...props }: TileImageProps) => {
  const classes = cn('mc-tile-image', className)
  const { imageUrl, ...restProps } = props

  return props.image ? (
    React.cloneElement(props.image, { className: classes, ...props })
  ) : (
    <Image className={classes} src={imageUrl} {...restProps} />
  )
}

TileImage.propTypes = {
  className: PropTypes.string,
  image: PropTypes.node,
  imageUrl: PropTypes.string,
  alt: PropTypes.string,
}

export default TileImage
